export * from './lib/components/artikel-info.component';

export * from './lib/artikel-info.shared';
export * from './lib/artikel-info.routes';
export * from './lib/artikel-info.providers';
